import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32858ff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "oem-learn-more" }, _ctx.attrs), [
      _createElementVNode("span", null, _toDisplayString(_ctx.showLearnMore.description), 1),
      _createElementVNode("a", {
        href: _ctx.showLearnMore.learnMoreUrl,
        target: "_black"
      }, "了解更多", 8, _hoisted_1),
      (_ctx.oemConfig.learnMore == 'each' && (_ctx.user.role.nameKey=='ROLE_NAME_CREATOR' || _ctx.user.role.nameKey=='ROLE_NAME_ADMIN'))
        ? (_openBlock(), _createBlock(_component_EditOutlined, {
            key: 0,
            onClick: _ctx.handleEditConfig
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ], 16),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "更新OEM",
      onOk: _ctx.handleSaveConfig,
      "ok-text": "保存",
      "cancel-text": "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          "label-col": {style: { width: '120px' }},
          model: _ctx.editModel,
          rules: _ctx.rules,
          ref: "formRef",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "描述文字",
              name: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.editModel.description,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editModel.description) = $event)),
                  maxlength: 1000,
                  allowClear: "",
                  autoSize: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "了解更多链接",
              name: "learnMoreUrl"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.editModel.learnMoreUrl,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editModel.learnMoreUrl) = $event)),
                  maxlength: 255,
                  allowClear: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}